import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/_layout/personal-informations')({
  beforeLoad: () => {
    throw redirect({ replace: true, to: '/informations-personnelles' })
  },
})
